/**
 * Shared display helpers for RoomBookingLog entries, used by both the single-booking
 * log panel (calendar/dashboard) and the admin log search panel — one source of truth
 * for action labels and for telling a series-level log row (bookingId === null) apart
 * from an instance-level one.
 */

import {
	BOOKING_TYPE_LABEL_WALK_IN,
	BOOKING_TYPE_LABEL_WITH_POINTS,
	BOOKING_TYPE_LABEL_WITHOUT_POINTS,
} from "../calendar/utils/bookingTypeLabel.js";

export const LOG_ACTIONS = [
	{ value: "created", label: "Erstellt" },
	{ value: "changed", label: "Geändert" },
	{ value: "cancelled", label: "Storniert" },
	{ value: "extracted", label: "Aus Serie gelöst" },
];

const ACTION_LABEL_BY_VALUE = Object.fromEntries(
	LOG_ACTIONS.map((action) => [action.value, action.label])
);

export const getActionLabel = (action) => ACTION_LABEL_BY_VALUE[action] || action;

// Values match the backend's `bookingKind` log field and search parameter.
export const LOG_BOOKING_KINDS = [
	{ value: "walk-in", label: BOOKING_TYPE_LABEL_WALK_IN },
	{ value: "points", label: BOOKING_TYPE_LABEL_WITH_POINTS },
	{ value: "without-points", label: BOOKING_TYPE_LABEL_WITHOUT_POINTS },
];

export const getLogBookingKindLabel = (log) =>
	LOG_BOOKING_KINDS.find((kind) => kind.value === log?.bookingKind)?.label ?? "Unbekannt";

// A log row is series-level when it has no roomBooking of its own (roomBooking IS NULL
// on the backend) — bookingId is then null and seriesId is set instead.
export const isSeriesLevelLog = (log) => log?.bookingId == null;

// Prefixed so a booking id and a series id that happen to share the same numeric value
// never collide when used as a TanStack Table grouping key.
export const getLogSubjectId = (log) => {
	if (log?.bookingId != null) return `booking-${log.bookingId}`;
	if (log?.seriesId != null) return `series-${log.seriesId}`;
	return "unknown";
};

export const getLogSubjectLabel = (log) => {
	if (log?.bookingId != null) return `Buchung #${log.bookingId}`;
	if (log?.seriesId != null) return `⟲ Serie #${log.seriesId}`;
	return "Unbekannt";
};
